import visuallyHidden from "@mittwald/flow-styles/dist/mixins/visuallyHidden";
import { opacity } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import { css } from "styled-components";
import { PropsType } from "../lib/Props";
import { breakpointProp } from "./breakpointProp";
export const visibilityMixinPropsType = new PropsType({
    _display: true,
    _hideIfEmpty: true,
    _interactionBlocked: true,
    _visible: true,
    _invisible: true,
    _visuallyHidden: true,
});
export const visibilityMixin = css `
  ${breakpointProp("_visible", (v) => `visibility: ${v ? "visible" : "hidden"}`)};
  ${breakpointProp("_invisible", (v) => `visibility: ${v ? "hidden" : "visible"}`)};
  ${breakpointProp("_display", (v) => `display: ${v}`)};
  ${breakpointProp("_visuallyHidden", (v) => `${v ? visuallyHidden : undefined}`)};
  ${breakpointProp("_interactionBlocked", (v) => v
    ? `
        pointer-events: none;
        & > * {
            opacity: ${opacity.disabled};
        }
    `
    : "")};
  ${breakpointProp("_hideIfEmpty", (v) => v
    ? `
        &:empty {
            display: none;
        }
    `
    : "")};
`;
export default visibilityMixin;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmlzaWJpbGl0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9taXhpbnMvdmlzaWJpbGl0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLGNBQWMsTUFBTSxrREFBa0QsQ0FBQztBQUM5RSxPQUFPLEVBQUUsT0FBTyxFQUFFLE1BQU0sZ0RBQWdELENBQUM7QUFDekUsT0FBTyxFQUFFLEdBQUcsRUFBRSxNQUFNLG1CQUFtQixDQUFDO0FBQ3hDLE9BQU8sRUFBRSxTQUFTLEVBQUUsTUFBTSxjQUFjLENBQUM7QUFDekMsT0FBTyxFQUFFLGNBQWMsRUFBc0IsTUFBTSxrQkFBa0IsQ0FBQztBQXFCdEUsTUFBTSxDQUFDLE1BQU0sd0JBQXdCLEdBQUcsSUFBSSxTQUFTLENBQXVCO0lBQzFFLFFBQVEsRUFBRSxJQUFJO0lBQ2QsWUFBWSxFQUFFLElBQUk7SUFDbEIsbUJBQW1CLEVBQUUsSUFBSTtJQUN6QixRQUFRLEVBQUUsSUFBSTtJQUNkLFVBQVUsRUFBRSxJQUFJO0lBQ2hCLGVBQWUsRUFBRSxJQUFJO0NBQ3RCLENBQUMsQ0FBQztBQUVILE1BQU0sQ0FBQyxNQUFNLGVBQWUsR0FBRyxHQUFHLENBQXNCO0lBQ3BELGNBQWMsQ0FDZCxVQUFVLEVBQ1YsQ0FBQyxDQUFDLEVBQUUsRUFBRSxDQUFDLGVBQWUsQ0FBQyxDQUFDLENBQUMsQ0FBQyxTQUFTLENBQUMsQ0FBQyxDQUFDLFFBQVEsRUFBRSxDQUNqRDtJQUNDLGNBQWMsQ0FDZCxZQUFZLEVBQ1osQ0FBQyxDQUFDLEVBQUUsRUFBRSxDQUFDLGVBQWUsQ0FBQyxDQUFDLENBQUMsQ0FBQyxRQUFRLENBQUMsQ0FBQyxDQUFDLFNBQVMsRUFBRSxDQUNqRDtJQUNDLGNBQWMsQ0FBQyxVQUFVLEVBQUUsQ0FBQyxDQUFDLEVBQUUsRUFBRSxDQUFDLFlBQVksQ0FBQyxFQUFFLENBQUM7SUFDbEQsY0FBYyxDQUNkLGlCQUFpQixFQUNqQixDQUFDLENBQUMsRUFBRSxFQUFFLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxDQUFDLGNBQWMsQ0FBQyxDQUFDLENBQUMsU0FBUyxFQUFFLENBQzNDO0lBQ0MsY0FBYyxDQUFDLHFCQUFxQixFQUFFLENBQUMsQ0FBQyxFQUFFLEVBQUUsQ0FDNUMsQ0FBQztJQUNDLENBQUMsQ0FBQzs7O3VCQUdlLE9BQU8sQ0FBQyxRQUFROztLQUVsQztJQUNDLENBQUMsQ0FBQyxFQUFFLENBQ1A7SUFDQyxjQUFjLENBQUMsY0FBYyxFQUFFLENBQUMsQ0FBQyxFQUFFLEVBQUUsQ0FDckMsQ0FBQztJQUNDLENBQUMsQ0FBQzs7OztLQUlIO0lBQ0MsQ0FBQyxDQUFDLEVBQUUsQ0FDUDtDQUNGLENBQUM7QUFFRixlQUFlLGVBQWUsQ0FBQyJ9